import { Component, Input, OnInit } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
})
export class ConfirmModalComponent implements OnInit {
    @Input() title: string = "";
    @Input() message: string = "";
    @Input() btnConfirmText: string = "generic.save";

    constructor(
            protected _toastController: ToastController,
            protected _translationService: TranslationService,
            private _modalController: ModalController) {
    }

    ngOnInit() {
    }

    public async save() {
        await this.dismiss(true);
    }
    
    public async cancel() {
        await this.dismiss(false);
    }

    public async dismiss(data: boolean) {
        await this._modalController.dismiss(data);
    }

}
